// @flow

import React from 'react'
import glamorous from 'glamorous'
import { css } from 'glamor'
import getContent from 'pp-react-l10n'
import {
  Pagination,
  Button,
  white,
  borderform,
  backgroundselected,
  grey200,
  grey300,
  grey700,
} from '@paypalcorp/pp-react'
import PageSwitcher from './page'

const Container = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})

const PaginationContainer = css({
  backgroundColor: white,
  marginTop: '1.75rem',
  '@media(max-width: 768px)': {
    marginTop: '0.75rem',
  },
})

const Page = css({
  height: '0.375rem',
  width: '0.375rem',
  borderRadius: '100%',
  backgroundColor: borderform,
  margin: '0 0.25rem',
  color: white,
  ':hover': {
    color: white,
    textDecoration: 'none',
  },
})

const ActivePage = css({
  backgroundColor: backgroundselected,
  color: white,
  transition: 'none',
})

const PageArrow = {
  height: '3rem',
  width: '3rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: grey700,
  background: grey200,
  fontWeight: 100,
  position: 'absolute',
  top: '8.75rem',
  ':hover': {
    color: grey700,
    background: grey300,
  },
  '@media(max-width: 768px)': {
    display: 'none',
    ':hover': {
      background: grey200,
    },
  },
}

const PageArrowLeft = {
  left: '-15%',
}

const PageArrowRight = {
  right: '-15%',
}

const PageSpace = css({
  display: 'none',
})

const CreateBtn = css({
  marginTop: 40,
  width: '60%',
  '@media(max-width: 425px)': {
    marginTop: 24,
    width: '80%',
  },
})

const l10n = getContent('pages/seller/landing')

type Props = {}

type State = {
  currentPage: number,
}

export default class SellerLanding extends React.Component<Props, State> {
  state = {
    currentPage: 1,
  }

  handleChange = page => {
    this.setState({
      currentPage: page,
    })
  }

  handleRoute = () => {
    this.props.history.push('/seller/details')
  }

  render() {
    return (
      <Container>
        <PageSwitcher currentPage={this.state.currentPage - 1} />
        <Pagination
          totalPageCount={3}
          currentPage={this.state.currentPage}
          onChange={this.handleChange}
          prevPageLabel={l10n('prevPageLabel')}
          nextPageLabel={l10n('nextPageLabel')}
          paginationLabel={l10n('paginationLabel')}
          className={`${PaginationContainer}`}
          pageClassName={`${Page}`}
          activePageClassName={`${ActivePage}`}
          arrowLeftClassName={`${css(PageArrow, PageArrowLeft)}`}
          arrowRightClassName={`${css(PageArrow, PageArrowRight)}`}
          arrowSpaceClassName={`${PageSpace}`}
        />
        <Button className={`${CreateBtn}`} onClick={this.handleRoute}>
          {l10n('button.createProfile')}
        </Button>
      </Container>
    )
  }
}
